import {
  InitialProcessRegistrationResponse,
  InitialProcessRegistrationPayload,
  GetRegistrationDetailsResponse,
} from "@/utils/types/NPS/Stepper/InitialProcessRegistration";
import { get, post } from "../axiosUitils";

const baseUrl = "/nps/verify-pan"; // Replace with your actual API endpoint

class InitialProcessRegistrationService {
  initialProcessRegistration = async (
    payload: InitialProcessRegistrationPayload
  ): Promise<InitialProcessRegistrationResponse> => {
    try {
      const response = await post<InitialProcessRegistrationResponse>(
        `${baseUrl}/`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in registration:", error);
      throw error;
    }
  };

  getRegistrationDetails =
    async (): Promise<GetRegistrationDetailsResponse> => {
      try {
        const response = await get<GetRegistrationDetailsResponse>(
          `${baseUrl}/`
        );
        return response;
      } catch (error) {
        console.error("Error in getting registration details:", error);
        throw error;
      }
    };
}

const instance = new InitialProcessRegistrationService();
export default instance;
